import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogConfirmacionComponent } from '../../../../components/shared/dialog-confirmacion/dialog-confirmacion.component';
import { DialogProcesandoComponent } from '../../../../components/shared/dialog-procesando/dialog-procesando.component';
import { ErroresService } from '../../../../core/services/errores.service';
import { IboxtoolsItem } from '../../../../models/iboxtools-item';
import { Contingentes } from '../../../../models/contingentes';
import { ContingentesService } from '../../../../services/contingentes.service';
import { ContingentesDetalleComponent } from '../contingentes-detalle/contingentes-detalle.component';
import { GruposLiquidacionService } from '../../../../services/gruposLiquidacion.service';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-contingentes-cab',
  templateUrl: './contingentes-cab.component.html',
  styleUrls: ['./contingentes-cab.component.css']
})
export class ContingentesCabComponent implements OnInit {

  @Input() personalId;
  @Input() fechaslist;
  @Input() gruposLiquidaciones;
  disabledEditing: boolean;
  contingente: Contingentes;
  verDetalle: boolean = false;
  isEditing: boolean = false;
  permisoEdicion: boolean = false;
  habilitarFormDetalle: boolean = false;
  MensajeError: string;

  //Control ibox
  contingenteHistoryList: any;
  contingentesList: Contingentes[];
  toolboxEnabled: boolean = false;
  onlyNew: boolean = true;
  contingentes: Contingentes[];
  buscando: boolean;
  cortarRegistro: boolean = false;

  ingreso: any;
  desdeAnterior: boolean = false;
  anteriorRetroactividad: boolean = false;
  contingentesInvalida: boolean = false;

  public cargaCompleta: boolean = false;

  @ViewChild('ChildContingenteDetalle') contingenteDetalle: ContingentesDetalleComponent;

  constructor(private contingenteService: ContingentesService,
    private dialog: MatDialog,
    private erroresService: ErroresService,
    private snackBar: MatSnackBar, 
    private gruposLiquidacionService: GruposLiquidacionService,
    private momentService: MomentSetService) { }

  ngOnInit(): void
  {
    this.obtenerContingentes(false);

    this.verPermiso();
  }

  async verPermiso() : Promise<void>  {
    let permisos = localStorage.getItem("Permisos");
    if (permisos.includes("Editar Contingentes")) this.permisoEdicion = true;
  }

  obtenerContingentes(agrupar)
  {
    this.buscando = true;
    this.contingenteService.getByPersonal(this.personalId, agrupar).subscribe(
      data =>
      {
        data.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
          currentValue.inicioLiquidacion = this.momentService.convertDateServer(currentValue.inicioLiquidacion);
          currentValue.finLiquidacion = this.momentService.convertDateServer(currentValue.finLiquidacion);
        });

        this.contingentes = data;
        this.buscando = false;
        this.cargaCompleta = true;
      },
      error =>
      {
        this.cargaCompleta = true;
        this.buscando = false;
        console.log(error);
      });
  }

  ngOnChanges(changes: SimpleChanges): void
  {
    //throw new Error("Method not implemented.");
  }

  async OnVisualizarDetalle(conti)
  {
    if (conti.id != 0)
    {
      this.obtenerHistorial(conti);
    }
    else
    {
      if (await this.verEstadoNomina())
      {
        this.verDetalle = true;
        this.contingente = conti;
        this.habilitarEdicion();
      }    
    }
  }

  async OnDeleteChange(event)
  {
    if (await this.validarEdicion(this.contingente))
    {
      this.MensajeError = "";
      let dialogRef = this.dialog.open(DialogConfirmacionComponent, {
        width: '400px',
      });

      dialogRef.componentInstance.mensaje = "¿Está seguro de eliminar?";

      dialogRef.afterClosed().subscribe(result =>
      {
        if (result != null && result)
        {
          let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
            width: '400px'
          });
          dialogProcesandoRef.componentInstance.Mensaje = "Eliminando...";

          this.contingenteService.eliminar(this.contingente.id).subscribe(
            response =>
            {
              this.snackBar.open("Eliminado correctamente.", "OK", { duration: 10000 });
              setTimeout(function ()
              {
                dialogProcesandoRef.close();
              });

              let contingente = this.contingentesList.filter(d => d.id != this.contingente.id)[0];
              if (contingente == undefined)
              {
                this.volverAtras();
              }

              this.obtenerHistorial(contingente);
            },
            error =>
            {
              if (error.status == 400)
              {
              }
              else
              {
                this.erroresService.MostrarErrorByStatus(error, "Error al eliminar");
              }
              dialogProcesandoRef.close();
            });
        }
      });
    }
  }

  OnBackChange()
  {
    this.volverAtras();
  }

  async OnEditChange()
  {
    if (await this.validarEdicion(this.contingente))
    {
      this.habilitarEdicion();
      var $this = this;
      setTimeout(function ()
      {
        $this.contingenteDetalle.form.controls['desde'].disable();
        $this.contingenteDetalle.form.controls['hasta'].disable();
      });
    }
  }

  OnPeriodChange(index: number)
  {
    let conti = this.contingentesList.find(d => d.id == index);
    this.contingente = conti;
    this.MensajeError = "";
  }

  OnCancelChange(e: boolean)
  {
    this.contingenteDetalle.setearForm(this.contingente);
    this.deshabilitarEdicion();
  }

  async OnSaveChange(e: boolean)
  {
    if (this.validarDatos())
    {
      let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
        width: '400px'
      });
      dialogProcesandoRef.componentInstance.Mensaje = "Guardando...";

      let formulario = this.contingenteDetalle.form.getRawValue();

      let datosCon: Contingentes = {
        id: formulario.id,
        personal: formulario.personal,
        desde: this.momentService.saveDateServer(formulario.desde, false),
        hasta: this.momentService.saveDateServer(formulario.hasta, false),
        claseContingente: formulario.claseContingente,
        cantidad: formulario.cantidad,
        diasConsumidos: formulario.cantidadConsumida,
        inicioLiquidacion: this.momentService.saveDateServer(formulario.inicioLiquidacion, false),
        finLiquidacion: this.momentService.saveDateServer(formulario.finLiquidacion, false)
      };

      this.contingenteService.guardar(datosCon, this.cortarRegistro).subscribe(
        contingente =>
        {
          contingente.desde = this.momentService.convertDateServer(contingente.desde);
          contingente.hasta = this.momentService.convertDateServer(contingente.hasta);
          contingente.inicioLiquidacion = this.momentService.convertDateServer(contingente.inicioLiquidacion);
          contingente.finLiquidacion = this.momentService.convertDateServer(contingente.finLiquidacion);

          setTimeout(function ()
          {
            dialogProcesandoRef.close();
          });

          this.snackBar.open("Contingente guardado", "OK", { duration: 10000 });

          this.deshabilitarEdicion();

          this.obtenerHistorial(contingente);
          //TODO. Modificar la forma de obtener la fecha sin el TimeZone
          this.contingenteDetalle.setearForm(contingente);
        },
        error =>
        {
          dialogProcesandoRef.close();

          if (error.status === 400)
          {
            this.MensajeError = this.erroresService.MostrarError400(error);
          }
          else
          {
            this.erroresService.MostrarErrorByStatus(error, "Error al guardar");
          }
        });
    }
  }

  async OnNewChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.habilitarEdicion();
      this.contingenteDetalle.form.controls['id'].setValue(0);
    }
  }

  async OnCutChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.cortarRegistro = true;
      this.habilitarEdicion();

      var $this = this;
      setTimeout(function ()
      {
        $this.contingenteDetalle.form.controls['hasta'].disable();
      });
    }
  }

  private deshabilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = true;
    this.isEditing = false;
    this.habilitarFormDetalle = false;
    this.cortarRegistro = false;
  }

  private habilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = false;
    this.isEditing = true;
    this.habilitarFormDetalle = true;
  }

  private volverAtras()
  {
    this.desdeAnterior = false;
    this.anteriorRetroactividad = false;
    this.MensajeError = "";
    this.contingenteHistoryList = [];
    this.contingentesList = [];
    this.habilitarFormDetalle = false;
    this.verDetalle = false;
    this.obtenerContingentes(false);
  }

  private obtenerHistorial(contingente: Contingentes)
  {
    this.contingenteService.getHistoryByClase(contingente.personal, contingente.claseContingente).subscribe(
      contingentes =>
      {
        contingentes.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
          currentValue.inicioLiquidacion = this.momentService.convertDateServer(currentValue.inicioLiquidacion);
          currentValue.finLiquidacion = this.momentService.convertDateServer(currentValue.finLiquidacion);
        });

        this.contingenteHistoryList = [];
        contingentes.forEach(d =>
        {
          let item = new IboxtoolsItem(d);
          this.contingenteHistoryList.push(item);
        });

        this.contingentesList = contingentes;
        this.verDetalle = true;
        this.contingente = contingente;
      },
      error =>
      {
        console.log(error);
      });
  }

  private validarDatos(): boolean
  {
    this.MensajeError = "";
    
    this.ingreso = this.fechaslist.find(d => d.claseFechaNavigation.codigo == "01");
    let desde = this.contingenteDetalle.form.get("desde").value.toDateString();
    let hoy = new Date()

    let fingreso = new Date(this.ingreso.desde).toDateString();
    this.desdeAnterior = false;
    if (Date.parse(desde) < Date.parse(fingreso))
    {
      this.desdeAnterior = true;
      this.contingenteDetalle.form.get("desde").setErrors({'desdeAnterior': true });
    }
    
    let canti = this.contingenteDetalle.form.get("cantidad").value;
    let consu = this.contingenteDetalle.form.get("cantidadConsumida").value;
    if (canti < consu)
    {
      this.contingenteDetalle.form.get("cantidad").setErrors({'menorConsumo': true });
    }

    if (this.contingenteDetalle.form.valid)
    {
      return true;
    }
    else
    {
      this.contingenteDetalle.form.markAllAsTouched();
      return false;
    }
  }

  private async verEstadoNomina() : Promise<boolean>
  {
    let estadoValido = true;
    this.gruposLiquidaciones = await this.gruposLiquidacionService.GetVigenteByPersonal(this.personalId).toPromise();
    if (this.gruposLiquidaciones.estadoActual == 1) {
      estadoValido = false;
      this.snackBar.open("Acción no válida durante el Cálculo de la Nómina. Actualice el registro de gestión.", "OK", { duration: 10000 });
    }
    return estadoValido;
  }

  private async validarEdicion(row) : Promise<boolean>
  {
    let edita = true;
    
    let estadoValido = await this.verEstadoNomina();
    if (estadoValido == false) edita = false;
    
    return edita;
  }
}
